import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AuthenticationService } from '../_services/authentication/authentication.service';
import { map } from 'rxjs/operators';

export const userPermissionsResolver: ResolveFn<any> = (route, state) => {
  const authService = inject(AuthenticationService);
  return authService
    .loadContext()
    .pipe(map((context: any) => context?.customers || []));
};
